import { makeStyles } from 'tss-react/mui';

// Constants
import {
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_REGULAR,
  FONT_WEIGHT_SEMIBOLD,
} from '../../../constants/typography';

export const useTableStyles = makeStyles()((theme, { isKiteUser } = {}) => ({
  table: {
    position: 'relative',
    borderCollapse: 'separate',
    width: '100%',
    overflow: 'visible',
    borderSpacing: `0 ${theme.spacing(2)}`,
    '& thead tr': {
      marginTop: 0,
    },
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0px 5px 15px rgba(44, 112, 172, 0.2)',
    borderRadius: '10px',
    marginTop: 16,
    '&:nth-child(1)': {
      marginTop: 0,
    },
    '& td, & th': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  cell: {
    fontFamily: isKiteUser ? 'Helvetica' : 'Proxima Nova',
    fontWeight: isKiteUser ? FONT_WEIGHT_REGULAR : FONT_WEIGHT_SEMIBOLD,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    borderBottom: 'none',
    letterSpacing: '0.1px',
    color: '#54565B',
    paddingBlock: theme.spacing(0.5),
    height: '56px',
    '&:nth-child(1)': {
      width: '40%',
    },
    '&:nth-child(2)': {
      width: '11%',
      justifyContent: 'flex-end',
    },
    '&:nth-child(3)': {
      width: '18%',
      justifyContent: 'flex-end',
    },
    '&:nth-child(4)': {
      width: '24%',
      justifyContent: 'center',
      '& button': {
        width: 89,
        height: 36,
      },
    },
    '&:nth-child(5)': {
      textAlign: 'right',
    },
  },
  headerCell: {
    color: isKiteUser ? theme.palette.darkGrey : theme.palette.black,
    fontWeight: isKiteUser ? FONT_WEIGHT_BOLD : FONT_WEIGHT_SEMIBOLD,
  },
}));
